import React, { ReactNode } from "react";
import "../../styles/styles.css"

const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <div style={{color:"black"}} className={`nc-LayoutPage relative `}>
        <div className="mx-auto rounded-xl sm:rounded-3xl lg:rounded-[40px] shadow-lg ">
          {children}
        </div>
    </div>
  );
};

export default Layout;
